import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/charts";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "../user/statsRoleBased.css";

const apiUrl =
  "https://jqh0cp25wl.execute-api.us-east-1.amazonaws.com/dev/tester-opts-count-day-wise";

const DemoColumn = () => {
  const [data, setData] = useState([]);
  const [selectedRange, setSelectedRange] = useState([new Date(), new Date()]);
  const storedUser = localStorage.getItem("user");
  const user = JSON.parse(storedUser);

  const toMidnightUTC = (date) => {
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    return utcDate;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedRange.length !== 2) {
        return;
      }
      try {
        const startDate = toMidnightUTC(new Date(selectedRange[0]));
        const endDate = toMidnightUTC(new Date(selectedRange[1]));

        const response = await axios.post(apiUrl, {
          start_date: startDate.toISOString().split("T")[0],
          end_date: endDate.toISOString().split("T")[0],
          tester_id: user.userId,
        });
        const optCount = response.data.opt_count;

        const currentWeekDates = [];
        const currentDateFormatted = new Date(startDate);
        while (currentDateFormatted <= endDate) {
          currentWeekDates.push(
            new Date(currentDateFormatted).toISOString().split("T")[0]
          );
          currentDateFormatted.setDate(currentDateFormatted.getDate() + 1);
        }

        const newData = currentWeekDates.map((date) => ({
          type: date,
          value: optCount[date] !== undefined ? optCount[date] : null,
        }));

        setData(newData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedRange, user.userId]);

  const handleDateChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectedRange([startDate, endDate]);
  };

  const pointCount = data.length;
  const denseAxis = pointCount > 14;

  const config = {
    data,
    xField: "type",
    yField: "value",
    height: 360,
    autoFit: true,
    xAxis: {
      label: {
        autoRotate: denseAxis,
        autoHide: true,
        autoEllipsis: true,
        formatter: (val) => {
          const date = new Date(val);
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          if (denseAxis) {
            return `${day}/${month}`;
          }
          return `${day}-${month}-${year}`;
        },
      },
    },
    yAxis: {
      label: {
        formatter: (v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : String(v)),
      },
    },
    style: {
      fill: "#38bdf8",
    },
    label: {
      text: (originData) => {
        const val = parseFloat(originData.value);
        if (val != null && !Number.isNaN(val) && val >= 0) {
          return val >= 1000 ? `${(val / 1000).toFixed(1)}k` : String(val);
        }
        return "";
      },
      offset: 8,
      position: "top",
    },
    legend: false,
  };

  return (
    <div className="stats-rb">
      <div className="stats-rb-header">
        <h1 className="stats-rb-title">Your Statistics</h1>
        <p className="stats-rb-subtitle">
          Select a date range to view your personal OTP statistics
        </p>
      </div>
      <div className="stats-rb-content">
        <div className="stats-rb-date-card">
          <div className="stats-rb-date-label">Date Range</div>
          <div className="statistics-container">
            <DateRangePicker
              onChange={handleDateChange}
              moveRangeOnFirstSelection={false}
              ranges={[
                {
                  startDate: selectedRange[0],
                  endDate: selectedRange[1],
                  key: "selection",
                },
              ]}
              className="custom-date-range-picker"
            />
          </div>
        </div>
        <div className="stats-rb-chart-card">
          <h3>Your OTP Count by Day</h3>
          <div className="stats-rb-chart-wrapper">
            <Column {...config} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoColumn;
